<template>

  <div class="content" v-loading="loading" v-if="item">

    <div class="mb-3">
      <router-link :to="{ name: 'Forms' }">
        <el-button plain size="small"><span class="el-icon-d-arrow-left"></span> Forms</el-button>
      </router-link>
      <router-link :to="{ name: 'FormSubmissions', params: { id: item.form._id } }">
        <el-button plain size="small"><span class="el-icon-arrow-left"></span> Submissions</el-button>
      </router-link>
    </div>

    <form-info :form="form" />

    <el-row>
      <el-col :span="17">

        <el-alert  v-if="item.userInfo.referer"
          title="Referer:" :closable="false"
          type="info">
          <small>&nbsp;
          <a :href="item.userInfo.referer" target="_blank">{{item.userInfo.referer}}</a>
          </small>
        </el-alert>
        &nbsp;

        <div v-for="(element, index) in item.fields" :key="index">
          <field-view :field="element.field" :is-encrypted="element.isEncrypted" :value="element.values" v-if="element.values" />
        </div>

      </el-col>
      <el-col :span="7" style="padding-left: 15px">

        <el-alert :closable="false"
                  title="Reservation info"
                  type="info" v-if="item.reservation">
          <div>
            <div v-if="item.reservation.partySize">
              <strong>Party size:</strong>
              <span>{{item.reservation.partySize}}</span>
            </div>
            <div v-if="item.reservation.reservationDate">
              <strong>Reservation time:</strong>
              <span>
                {{item.reservation.reservationDate | date}}
                {{item.reservation.reservationDate | time}}
              </span>
            </div>
            <div v-if="item.reservation.totalCountForClient">
              <strong>Reservations from this client:</strong>
              <span>
                {{item.reservation.totalCountForClient}}
              </span>
            </div>
          </div>
        </el-alert>

        <br />

        <el-alert :closable="false"
                  title="User info"
                  type="info">
          <div>

            <div v-if="item.userInfo.ip">
              <strong>IP:</strong>
              <span>
                <span v-if="item.userInfo.geo && item.userInfo.geo.country" :class="'flag flag-' + item.userInfo.geo.country.toLowerCase()"></span>

                <span v-if="item.isEncrypted">
                  <crypt-value :value="item.userInfo.ipEncrypted" :label="item.userInfo.ip" />
                </span>
                <span v-else>
                  {{item.userInfo.ip}}
                </span>
              </span>
            </div>
            <div v-if="item.createdAt">
              <strong>Created Date:</strong>
              <span>
                {{item.createdAt | date}}
                {{item.createdAt | time}}
              </span>
            </div>
            <div v-if="item.userInfo.browser">
              <strong>Browser & OS:</strong>
              <span>{{item.userInfo.browser}}</span>
            </div>
            <div v-if="item.userInfo.adGroup">
              <strong>Ad group:</strong>
              <span>{{item.userInfo.adGroup}}</span>
            </div>
            <div v-if="item.userInfo.campaign">
              <strong>Campaign:</strong>
              <span>{{item.userInfo.campaign}}</span>
            </div>
            <div v-if="item.userInfo.landingPage">
              <strong>Landing page:</strong>
              <span>{{item.userInfo.landingPage}}</span>
            </div>
            <div v-if="item.userInfo.pageDepth">
              <strong>Page depth:</strong>
              <span>{{item.userInfo.pageDepth}}</span>
            </div>
            <div v-if="item.userInfo.trafficType">
              <strong>Traffic type:</strong>
              <span>{{item.userInfo.trafficType}}</span>
            </div>
            <div v-if="item.userInfo.matchedQuery">
              <strong>Matched query:</strong>
              <span>{{item.userInfo.matchedQuery}}</span>
            </div>
          </div>
        </el-alert>

        <el-alert style="margin-top: 15px"
                  :closable="false" v-if="item.paymentInfo"
                  title="Payment info"
                  type="info">
          <div>

            <div>
              <span v-if="item.paymentInfo.state === 'approved'" class="text-success">
                <span class="el-icon-goods"></span> <strong>{{item.paymentInfo.state}}</strong>
              </span>
              <span v-else class="text-danger">
                <span class="el-icon-goods"></span> <strong>{{item.paymentInfo.state}}</strong>
              </span>
            </div>
            <strong>ID:</strong> {{item.paymentInfo.id}}
            <h6>Payer</h6>
            <div>
              {{item.paymentInfo.payer.payer_info.first_name}} {{item.paymentInfo.payer.payer_info.last_name}} <{{item.paymentInfo.payer.payer_info.email}}>
            </div>
            <h6>Shipping address</h6>
            <div><strong>City:</strong> {{item.paymentInfo.payer.payer_info.shipping_address.city}}</div>
            <div><strong>Country code:</strong> {{item.paymentInfo.payer.payer_info.shipping_address.country_code}}</div>
            <div><strong>Address line1:</strong> {{item.paymentInfo.payer.payer_info.shipping_address.line1}}</div>
            <div><strong>Postal code:</strong> {{item.paymentInfo.payer.payer_info.shipping_address.postal_code}}</div>
            <div><strong>Recipient name:</strong> {{item.paymentInfo.payer.payer_info.shipping_address.recipient_name}}</div>
          </div>
        </el-alert>

      </el-col>
    </el-row>

  </div>
</template>
<style>
  .iframe-preview {
    margin-top: 15px;
    border: 1px solid #f2f2f2;
  }
</style>
<script>
  import '../assets/flags.css';
  import moment from 'moment';
  import fieldView from '../components/fieldView';
  import FormInfo from '../components/Forms/Info';
  import cryptValue from '../components/cryptValue';

  export default {
    components: {
      fieldView,
      FormInfo,
      cryptValue
    },
    mounted() {
      this.retrieveItem(this.$route.params.id, this.$route.params.filledId);
    },
    methods: {
      async retrieveItem(formId, id) {
        this.loading = true;
        try {
          this.form = await this.$axios.get(`/v1/forms/${formId}`).then(res => res.data);
          this.item = await this.$axios.get(`/v1/forms/${formId}/submissions/${id}`).then(res => res.data);
        } catch (error) {
          this.$message.error(error.message || error);
        }
        this.loading = false;
      }
    },
    filters: {
      date(value) {
        return moment(value).format('DD-MM-YYYY');
      },
      time(value) {
        return moment(value).format('hh:mm:ss');
      }
    },
    data() {
      return {
        loading: false,
        item: null
      }
    }
  };
</script>



// WEBPACK FOOTER //
// SubmissionDetails.vue?40cb621c